export const ORDERS_SECTION_ROUTES = {
  orderList: '/orders',
  ordersExport: '/orders/export',
  orderDetails: '/orders/:id',
  orderEdit: '/orders/:id/edit',
  refundOrder: '/orders/:id/refund',
  autoCancel: '/orders/auto-cancel',
};
